import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ffcb5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = {
  key: 0,
  class: "recently"
}
const _hoisted_4 = { class: "recently-title" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "collect" }
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = { class: "list collect-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menu-list" }
const _hoisted_12 = { class: "all-menu-list" }
const _hoisted_13 = { class: "menu-title" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["title"]


import { ref, computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { Search } from '@element-plus/icons-vue'
import MenuCollect from '@/components/Layout/MenuCollect.vue'

const __default__ = {
  name: 'Home'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $t: any = inject('$t')

const store = useStore()
const router = useRouter()

const searchMenu = ref('')

/**
 * 菜单展示列表-包含过滤条件
 */
const allMenuList = computed(() => {
  if (searchMenu.value === '') {
    return allList.value
  }
  const list: any[] = []
  allList.value.forEach(item => {
    const hasMenuList = item.menuList.filter((menu: any) => {
      return menu.menuName.indexOf(searchMenu.value) !== -1
    })
    if (hasMenuList.length > 0) {
      list.push({
        ...item,
        menuList: hasMenuList
      })
    }
  })
  return list
})

/**
 * 收藏列表
 */
const collectList = computed(() => {
  return store.state.menu.collectList
})

/**
 * 最近访问
 */
const recentVisitList = computed(() => {
  return store.state.menu.recentVisitList
})

/**
 * 所有菜单
 */
const allList = computed(() => {
  return parseLang(store.state.menu.menuList || [])
})

const parseLang = (list: any[]) => {
  return list.map(item => {
    return {
      ...item,
      menuList: flatMenu([], item.childMenuList ?? []).map((menu: any) => {
        return {
          ...menu,
          menuName: $t(menu.menuName)
        }
      })
    }
  })
}

const flatMenu = (arr: any[], menus: any[]) => {
  menus.forEach((item: any) => {
    if (item.menuRouteUrl) {
      arr.push(item)
    }
    if (item.childMenuList?.length) {
      flatMenu(arr, item.childMenuList)
    }
  })
  return arr
}

const toPage = (route: string) => {
  route && router.push(route)
}

const getCollectStatus = (item: any) => {
  return collectList.value.some((menu: any) => menu.menuId === item.menuId)
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    style: {"height":"100%","box-sizing":"border-box"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            clearable: "",
            modelValue: searchMenu.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchMenu).value = $event)),
            placeholder: _unref($t)('main_header_placeholder')
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_el_icon, {
                class: "el-input__icon",
                size: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Search))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        (_unref(recentVisitList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($t)('main_header_recent_visit')) + "：", 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recentVisitList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "menu-item",
                    key: item.routeUrl,
                    onClick: ($event: any) => (toPage(item.routeUrl))
                  }, _toDisplayString(_unref($t)(item.name)), 9, _hoisted_6))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('main_collection_function')), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collectList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "menu-item",
                key: item.menuRouteUrl,
                onClick: ($event: any) => (toPage(item.menuRouteUrl))
              }, _toDisplayString(_unref($t)(item.menuName)), 9, _hoisted_10))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allMenuList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.menuId,
                class: "item"
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref($t)(item.menuName)), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menuList, (subItem) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: subItem.menuId
                  }, [
                    (subItem.menuRouteUrl)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "menu-item",
                          onClick: ($event: any) => (toPage(subItem.menuRouteUrl))
                        }, [
                          _createElementVNode("div", {
                            class: "menu-item-span",
                            title: subItem.menuName
                          }, _toDisplayString(subItem.menuName), 9, _hoisted_15),
                          _createVNode(MenuCollect, {
                            menuItem: subItem,
                            class: _normalizeClass(['icon-star', getCollectStatus(subItem) ? 'collect-item' : null])
                          }, null, 8, ["menuItem", "class"])
                        ], 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})